import { faWarehouseFull } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Select } from "antd";
import useWarehouse from "../../customHooks/useWarehouse";
import { useGlobalFilters } from "../../providers/GlobalFiltersProvider";

export default function WarehouseFilter() {
    const { filters, setFilter } = useGlobalFilters();
    const { data: warehouses = [] } = useWarehouse();
    return (
        <Select
            className="!h-[34px] w-72"
            mode="multiple"
            allowClear
            maxTagCount="responsive"
            placeholder="Select Warehouse(s)"
            value={filters.warehouseIds}
            prefix={<FontAwesomeIcon icon={faWarehouseFull} className="text-gray-500 mr-1" />}
            onChange={value => setFilter("warehouseIds", value)}
            options={warehouses?.map(w => ({
                label: w.name,
                value: w.id
            }))}
        />
    );
}